module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ../node_modules/file-loader/dist/cjs.js?name=fonts/[name].[ext]!../node_modules/font-awesome/fonts/fontawesome-webfont.woff2
// module id = 543
// module chunks = 0